import Router from "router/router";
export default [
  {
    title: "首页",
    location: Router.Home.path,
  },
  {
    title: "隐私保护",
    location: {
      pathname: Router.Help.path,
      search: `categoryId=1&articleId=19`,
    },
  },
  {
    title: "联系我们",
    location: {
        pathname:`${Router.News.realPath}/33`,
        search:`menuType=1&categoryId=1`
    },
  },
  {
    title: "免责条款",
    location: {
      pathname: Router.Help.path,
      search: `categoryId=1&articleId=18`,
    },
  },
  {
    title: "公司简介",
    location: Router.Introduce.path,
  },
  {
    title: "招商入驻",
    location: {
      pathname: Router.Merchant.path,
    },
  },
  {
    title: "平台总则",
    location: {
      pathname: Router.Help.path,
      search: `categoryId=1&articleId=17`,
    },
  },
];
